import { tdsTcsActionTypes } from '@Actions/configurations/tdsTcsActions';

const TdsTcsReducer = (state = { }, action) => {
  switch (action.type) {
  case tdsTcsActionTypes.CREATE_TDS_TCS.LOADING: {
    const { createTdsTcsLoading } = action;
    return {
      ...state,
      createTdsTcsLoading,
    };
  }
  case tdsTcsActionTypes.GET_TDS_TCS.LOADING: {
    const { getTdsTcsLoading } = action;
    return {
      ...state,
      getTdsTcsLoading,
    };
  }
  case tdsTcsActionTypes.GET_TDS_TCS.SUCCESS: {
    const { tdsTcs } = action;
    return {
      ...state,
      tdsTcs,
    };
  }
  case tdsTcsActionTypes.GET_DEFAULT_TDS_TCS.LOADING: {
    const { getDefaultTdsTcsLoading } = action;
    return {
      ...state,
      getDefaultTdsTcsLoading,
    };
  }
  case tdsTcsActionTypes.GET_DEFAULT_TDS_TCS.SUCCESS: {
    const { defaultTdsTcs } = action;
    return {
      ...state,
      defaultTdsTcs,
    };
  }
  case tdsTcsActionTypes.UPDATE_TDS_TCS.LOADING: {
    const { updateTdsTcsLoading } = action;
    return {
      ...state,
      updateTdsTcsLoading,
    };
  }
  case tdsTcsActionTypes.DELETE_TDS_TCS.LOADING: {
    const { deleteTdsTcsLoading } = action;
    return {
      ...state,
      deleteTdsTcsLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default TdsTcsReducer;
